// ExcelHandler.js
import * as XLSX from "xlsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from 'uuid';



const ExcelHandler = ({ fetchContacts, user }) => {
  const handleExportExcel = async (data) => {
    try {
      // Fetch user data from /api/users
      const usersResponse = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/users`, {
        params: { role: user.role }, // Optional: Filter by role if needed
      });
      const users = usersResponse.data; // Assuming this returns an array of { id, name, ... }

      // Create a userId-to-name mapping
      const userMap = new Map(users.map((u) => [u.id, u.name]));

      // Map the data to replace userId with user name
      const exportData = data.map((contact ,index) => ({
        ID: index +1, // Include ID if available
        BatchName: contact.batchName,
        Name: contact.name || "",
        Phone: contact.MobileNumber || "",
        Location: contact.location || "",
        Email: contact.email || "",
        // "User Name": userMap.get(contact.userId) || "Unknown", // Replace userId with name
      }));

      // Generate Excel file
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");
      XLSX.writeFile(workbook, "contacts_export.xlsx");

      toast.success("Data exported successfully!", {
        position: "top-right",
        autoClose: 3000,
      });


      
    } catch (error) {
      toast.error("Failed to export data.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
    }

  // ExcelHandler.js
// ExcelHandler.js
// const handleImportExcel = async (event, user) => {
//   const file = event.target.files[0];
//   if (!file) return;

//   // / Show loading toast when the process starts
//   const toastId = toast.loading("Processing your Excel file...", {
//     position: "top-right",
//   });


//   const reader = new FileReader();
//   const batchId = uuidv4();
//   reader.onload = async (e) => {
//     try {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(worksheet);

//       const formattedData = jsonData.map((row) => ({
//         name: row.Name || row.name || "",
//         MobileNumber: row.Phone || row.MobileNumber || "",
//         location: row.Location || row.location || "",
//         email: row.Email || row.email || "",
//         userId: user.id,
//         batchId,
//         geoid: row.Geoid || uuidv4(),
//       }));

//       console.log("Sending to backend:", formattedData);

//       // Send each contact individually
//       for (const contact of formattedData) {
//         await axios.post(
//           `${process.env.REACT_APP_SERVER_API}/api/contacts`,
//           contact, // Send single contact object
//           { headers: { "Content-Type": "application/json" } }
//         );
//       }

//       fetchContacts();

      
//    toast.update(toastId, {
//           render: "Data imported successfully!",
//           type: "success",
//           isLoading: false,
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });



//       } catch (error) {
//         console.error("Error importing Excel:", error);

//         toast.update(toastId, {
//           render: error.response?.data.message || "Failed to import data. Check console for details.",
//           type: "error",
//           isLoading: false,
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });

//         if (error.response) {
//           console.log("Server response:", error.response.data);
//         }
//       }
//     };
//     reader.readAsArrayBuffer(file);
//   };




const handleImportExcel = async (event, user) => {
  const file = event.target.files[0];
  if (!file) return;

  const toastId = toast.loading('Processing your Excel file...', {
    position: 'top-right',
  });

  const reader = new FileReader();
  reader.onload = async (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Generate one batchId for the entire Excel file
      const batchId = uuidv4();
      const batchName = `Batch_${file.name.split('.')[0]}_${new Date().toISOString().replace(/[:.]/g, '-')}`;
      const formattedData = jsonData.map((row) => ({
        name: row.Name || row.name || '',
        MobileNumber: row.Phone || row.MobileNumber || '',
        location: row.Location || row.location || '',
        email: row.Email || row.email || '',
        userId: user.id,
        batchId,
        batchName, // Apply the same batchId to all contacts
        geoid: row.Geoid || uuidv4(), // Unique geoid per contact
      }));

      // Log data to verify batchId consistency
      console.log('Sending to backend:', JSON.stringify(formattedData, null, 2));

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}/api/contacts`,
        formattedData,
        { headers: { 'Content-Type': 'application/json' } }
      );

      // Assuming fetchContacts is defined elsewhere
      fetchContacts();

      toast.update(toastId, {
        render: `Batch ${response.data.batchId} imported successfully!`,
        type: 'success',
        isLoading: false,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error('Error importing Excel:', error);
      toast.update(toastId, {
        render: error.response?.data.message || 'Failed to import data.',
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  reader.readAsArrayBuffer(file);
};







return { handleImportExcel, handleExportExcel };
};

export default ExcelHandler;